<h1 mat-dialog-title i18n *ngIf="!dialogData.user.suspended">Suspend Account <small class="align-top">- {{dialogData.user.email}}</small></h1>
<h1 mat-dialog-title i18n *ngIf="dialogData.user.suspended">Unsuspend Account <small class="align-top">- {{dialogData.user.email}}</small></h1>

<form (ngSubmit)="onFormSubmit()">
	<div mat-dialog-actions class="row mb-0">
		<div class="col-6 text-center">
			<button
				class="w-100"
				mat-flat-button
				mat-dialog-close
				i18n
			>Cancel</button>
		</div>
		<div class="col-6 text-center">
			<button
				class="w-100 suspend-submit"
				type="submit"
				mat-flat-button
				color="primary"
				i18n
				[disabled]="false"
				cdkFocusInitial
			>Ok</button>
		</div>
	</div>
</form>
